import React, { FC } from 'react';
import { Text } from 'atoms/Text/Text';
import { Styles } from './styles';

export type ProductThumbProps = {
  title: string;
  image: () => React.ReactElement;
  onClick: () => void;
  whiteBg?: boolean;
};

export const ProductThumb: FC<ProductThumbProps> = ({
  title,
  onClick,
  image,
  whiteBg,
}: ProductThumbProps) => {
  return (
    <div onClick={onClick}>
      <Styles.Content>
        <Styles.Image whiteBg={whiteBg}>{image && image()}</Styles.Image>
        <Styles.Text>
          <Text.caption2>{title}</Text.caption2>
        </Styles.Text>
      </Styles.Content>
    </div>
  );
};
